'use client';

import React, { ReactNode } from 'react';
import { Container } from '@/components/client/Container/Container';
import { Section } from '@/components/client/Section/Section';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { ServiceCardsSection } from '@/features/client/ServiceCardsSection/ServiceCardsSection';
import { ContentLayout } from '@/features/client/Services/components/ContentLayout/ContentLayout';
import { RequestForm } from '@/features/client/Forms/RequestForm/RequestForm';
import { ServicesNavMenu } from '@/features/client/Services/components/ServicesNavMenu/ServicesNavMenu';
import image from '@/public/images/services/main_page/air_conditiong.webp';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContentV2 } from '@/features/client/Services/components/Content/ContentV2';
import { IExtraContent } from '@/features/client/Services/components/Content/ExtraContent/ExtraContent';
import chooseImage from '@/public/images/services/ac_installation/choose.jpg';
import installationImage from '@/public/images/services/ac_installation/installation-process.jpg';

import licensed from '@/public/images/services/ac_installation/licensed.png';
import pricing from '@/public/images/services/ac_installation/pricing.png';
import customerService from '@/public/images/services/ac_installation/customer-service.png';
import tailored from '@/public/images/services/ac_installation/stay-at-home.png';
import learning from '@/public/images/services/ac_installation/learning.png';
import safety from '@/public/images/services/ac_installation/safety.png';
import measurement from '@/public/images/services/ac_installation/measurement.png';
import time from '@/public/images/services/ac_installation/time.png';
import warranty from '@/public/images/services/ac_installation/warranty.png';
import clear from '@/public/images/services/air_conditioning/clear.png';
import air from '@/public/images/services/air_conditioning/air.png';
import energy from '@/public/images/services/air_conditioning/energy.png';
import control from '@/public/images/services/air_conditioning/control.png';
import customerService2 from '@/public/images/services/heating-installation/customerService.png';
import garanty from '@/public/images/services/heating/garanty.png';
import chooseImage2 from '@/public/images/services/heating-installation/chooseImage.jpg';

interface Data {
  title: ReactNode;
  description: ReactNode;
  extraContent: IExtraContent[];
}

const data: Data = {
  title: '',
  description: '',
  image: '',
  offer_title: '',
  offer_data: [],
  banner_title: ``,
  banner_description: ``,
  banner_with_button: false,

  why_title: '',
  why_description: ``,
  why_items: [],
  why_footerText: '',
  extraContent: [
    {
      title: 'Our Ductless Mini-Split AC Installation Services in San Diego',
      description:
        'At Tytum, we specialize in the expert installation of ductless mini-splits in San Diego, CA, combining top-tier technology with white-glove service to provide homeowners and businesses across the area with custom HVAC solutions that deliver long-term comfort, energy savings, and peace of mind.',
      image: chooseImage,
      items: [
        {
          title: 'In-Home Consultation',
          image: tailored,
          description:
            'Our comfort specialists visit your home or business to assess your specific needs and design a system that perfectly suits your space, both visually and functionally, as well as financially.',
        },
        {
          title: 'Professional Sizing and System Selection',
          image: measurement,
          description:
            'We’ll guide you through selecting the right ductless mini-split air conditioner in San Diego, without upselling. You’ll get exactly the system capacity your space requires.',
        },
        {
          title: 'Expert Installation',
          image: licensed,
          description:
            'Our licensed, insured, and highly trained ductless mini-split installers in San Diego will securely install all system components. They’ll work efficiently and respect your space, using protective coverings to minimize dust and cleaning up after the job is done.',
        },
        {
          title: 'System Calibration and Testing',
          image: customerService2,
          description:
            'When your mini-split AC in San Diego is installed, we don’t just power on and walk away. We’ll test the system for stable performance and make final adjustments to maximize energy efficiency and comfort.',
        },
        {
          title: 'Personalized Guidance',
          image: clear,
          description:
            'Before we leave, we’ll walk you through everything you need to know and answer all your questions to make sure you feel confident and comfortable using your new system.',
        },
        {
          title: 'Ongoing Support',
          image: time,
          description:
            'We are committed to your satisfaction long after installation day, offering maintenance plan options to keep your mini-split system efficient and fast service if you ever need repairs or adjustments.',
        },
        {
          title: 'Comprehensive Warranties',
          image: warranty,
          description:
            'Every ductless mini-split AC installation in San Diego that we perform includes strong warranties for both parts and labor. Your investment is always secure and well-protected with Tytum.',
        },
      ],
      footerText: '',
    },
    {
      title: 'Benefits of Ductless Mini-Split AC Systems',
      description:
        'A ductless mini-split system is a compact, highly efficient HVAC solution consisting of an outdoor compressor/condenser unit and one or more indoor air-handling units connected by a small conduit, requiring only a small hole in the wall, with no extensive ductwork involved. If you’re upgrading your current HVAC setup, remodeling, or simply seeking more efficient climate control, this system might be your perfect match.<br /><br />With over 20 years of experience in providing ductless mini-split installation service in San Diego, we at Tytum understand all the benefits it offers.',
      image: image,
      items: [
        {
          title: 'Zoned Comfort',
          image: control,
          description:
            'You can independently control the temperature in different rooms or “zones” of your home, setting the ideal temperature without affecting the rest of the house.',
        },
        {
          title: 'Energy Efficiency',
          image: energy,
          description:
            'Without ductwork, you avoid the typical 20–30% energy loss associated with central systems. Many models also include inverter technology, further reducing your utility bills.',
        },
        {
          title: 'Flexible Installation',
          image: tailored,
          description:
            'Offering non-invasive ductless installation, mini-splits are a savior for retrofitting rooms without ducts, home additions, garages, or basements.',
        },
        {
          title: 'Sleek Design',
          image: clear,
          description:
            'Modern mini-split systems feature slim, wall-mounted units with a clean, minimalistic look that seamlessly blends into your space.',
        },
        {
          title: 'Quiet Operation',
          image: time,
          description:
            'Quiet thanks to their variable speed compressors and insulated design, mini-splits are perfect for bedrooms, nurseries, home offices, and other noise-sensitive areas.',
        },
        {
          title: 'Cleaner Indoor Environment',
          image: air,
          description:
            'Ductless systems include multi-stage filtration, improving air quality and reducing exposure to airborne particles. ',
        },
      ],
      footerText: '',
      banner: {
        title: 'Flexible Comfort Solutions',
        description:
          'Reach out to Tytum today and discover how ductless comfort can transform your space.',
        withButton: true,
      },
    },
    {
      title: 'Is a Mini Split Air Conditioner Right for Your Home?',
      description:
        'Are you looking for “mini-split AC installation near me” options, and still wondering if it’s an optimal choice for your property? In general, mini-splits work great where a traditional central AC system isn’t practical or when homeowners want better temperature control and lower energy use without a full system replacement.',
      items: [
        {
          title: 'Homes Without Existing Ductwork',
          image: measurement,
          description:
            'Mini-split ACs are a quick and cost-effective solution for older homes and historic buildings that lack central air ducts or use window units or baseboard heating.',
        },
        {
          title: 'Home Additions, ADUs, and Remodels',
          image: tailored,
          description:
            'With mini-splits, you can independently cool newly added areas, such as basements, attics, lofts, or enclosed patios, without overloading your main HVAC system.',
        },
        {
          title: 'Converted Spaces and Offices',
          image: clear,
          description:
            'Cooling needs in converted garages, home offices, and studios may change during the day. Enjoy flexible temperature control just where you need it, making these spaces comfortable year-round.',
        },
        {
          title: 'Multi-Storey Homes with Uneven Cooling',
          image: safety,
          description:
            'Are your upstairs rooms usually warmer than the rest of the house? A ductless mini-split AC can balance things out by cooling separate rooms or floors and eliminating hot or cold spots.',
        },
        {
          title: 'Targeted Cooling for Specific Spaces',
          image: energy,
          description:
            'Maintain comfort while avoiding wasted energy in bedrooms, home gyms, sunrooms, guest rooms, server rooms, or workshops that have varying cooling needs.',
        },
      ],
    },
    {
      title: 'Types of Mini-Split AC Systems We Install',
      image: installationImage,
      description:
        'When it comes to mini-split AC system installation in San Diego, there’s no one-size-fits-all solution. At Tytum, we offer and install a wide range of ductless mini-splits to suit different spaces, needs, and budgets.',
      items: [
        {
          title: '1. Single-Zone Systems',
          description:
            'Consisting of one outdoor unit connected to one indoor air handler, this system provides efficient, focused climate control exactly where you need it. It’s a choice for a single space, such as a bedroom, garage, home office, or ADU.',
        },
        {
          title: '2. Multi-Zone Systems',
          description:
            'One outdoor unit can power up to five or more indoor units, with individual thermostats for personalized comfort, allowing you to control each room or zone separately. This option is especially popular in homes with additions, growing families, or homeowners seeking to replace outdated central systems with more efficient ones.',
        },
        {
          title: '3. Wall-Mounted Indoor Units',
          description:
            'Sleek, low-profile wall units are known for their discreet design and excellent air distribution. They are versatile and work well in nearly any type of room, sitting high on the wall and matching your room aesthetic to a tee. ',
        },
        {
          title: '4. Ceiling Cassette Systems',
          description:
            'It’s a great option for those seeking a more integrated look. Installed flush with the ceiling, these systems distribute air in multiple directions and remain largely out of sight, perfect for living rooms, conference rooms, or upscale interiors.',
        },
        {
          title: '5. Floor-Mounted Mini-Splits',
          description:
            'These are installed at the base of the wall, similar to radiators, and are great for rooms with low ceilings, angled walls, or where high wall space is unavailable.',
        },
      ],
    },
    {
      title:
        'Why Choose Tytum as Your Ductless Mini-Split Installers in San Diego',
      description:
        'When searching for a mini-split AC installation near me, look no further than Tytum. Providing HVAC services in San Diego for over 20 years delivers an end-to-end experience marked by technical excellence, professionalism, and transparency. Here is why homeowners choose us for mini-split installation in San Diego.',
      image: chooseImage2,
      items: [
        {
          title: 'Local Knowledge',
          image: learning,
          description:
            'We understand the region’s microclimates, home styles, and unique HVAC needs and are familiar with local building codes, permit requirements, and rebate programs. This ensures a smooth, fully compliant installation from start to finish.',
        },
        {
          title: 'Professional Installation',
          image: safety,
          description:
            'Our team consists of fully licensed and insured techs who work with minimal disruption to your home. We employ clean, meticulous methods and ensure that every line is properly sealed, secured, and thoroughly tested for long-term reliability.',
        },
        {
          title: 'Transparent Pricing',
          image: pricing,
          description:
            'You’ll always know exactly what you’re getting, what it costs, and why. No vague estimates. No last-minute fees. Just clear, upfront pricing with detailed breakdowns and real value.',
        },
        {
          title: 'Excellent Customer Service',
          image: customerService,
          description:
            'We provide ongoing support and maintenance to ensure your ductless mini-split system stays in top condition. Need help? Just give us a call, and our team is ready with quick, expert assistance whenever you need it.',
        },
        {
          title: 'Quality Guaranteed',
          image: garanty,
          description:
            'We proudly back every ductless mini-split installation with our 100% satisfaction guarantee. If something isn’t right, we’ll make it right, no excuses, no added stress.',
        },
      ],
      footerText: '',
      banner: {
        title: 'Book your free Estimate',
        description:
          'Cut your energy bills and stay cool. Find out how Tytum can help. Book your free estimate today.',
        bookServiceButton: true,
      },
    },
    {
      title: 'Frequently Asked Questions (FAQ)',
      description: '',
      items: [
        {
          title: '✓ How long does installation take?',
          description: `Installing a single-zone system is usually a quick, one-day job. Multi-zone systems, which involve multiple indoor units, generally take between one and three days to complete, depending on the home's layout and the complexity of the installation. Our mini-split AC installers in San Diego always strive to do the job quickly without compromising quality.`,
        },
        {
          title: '✓ How much does it cost to install a mini-split?',
          description:
            'The cost of mini-split installation in San Diego varies depending on the number of zones or rooms, unit type, brand, and model, any electrical or structural upgrades needed, and permit requirements. On average, a single-zone system costs from $3,000 to $5,000+, including equipment and professional installation. Multi-zone systems can range from $6,000 to $12,000+.',
        },
        {
          title:
            '✓ Do ductless mini-split AC systems require a lot of maintenance?',
          description:
            'Mini-splits are low-maintenance compared to traditional central air systems. They don’t use ductwork, so you avoid duct cleaning, leaks, and dust buildup that often reduce efficiency. Providing out-of-the-box ductless mini-split system installation in San Diego, Tytum also offers professional annual checkups and planned maintenance programs to maximize your system’s service life.',
        },
      ],
      footerText: '',
    },
  ],
};

const DuctlessInstallation = () => {
  return (
    <div>
      <MainSectionLayout variant="primary" layout="sline">
        <MainSection
          label="Service Details"
          title="Mini Split Air Conditioner Installers in San Diego"
          description="Ductless mini split AC installation in San Diego is one of our core services designed for homeowners and businesses who want efficient, zoned cooling without the cost and disruption of ductwork. We offer complete, start-to-finish solutions implemented by licensed technicians with extensive hands-on experience in HVAC systems. We ensure quality and reliable results from day one."
          withContactButton
        />
      </MainSectionLayout>

      <Section variant="secondary">
        <Container>
          <ContentLayout
            contentLeft={
              <>
                <ServicesNavMenu />
                <RequestForm />
              </>
            }
            contentRight={<ContentV2 data={data} />}
          />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ServiceCardsSection shortVariant={true} />
        </Container>
      </Section>

      <Section variant="secondary">
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};

export default DuctlessInstallation;
